import {
  AddPaymentMethodFormSubmitEvent,
  AppliedPayableRestriction,
  CreditAppliedActionPayload,
  PadAgreementFormSubmitEvent,
  PaymentAccount,
  PaymentAccountsPushNotificationMetadata,
  SelectPaymentMethodFormSubmitEventOnBackNavigation,
  SelectPaymentMethodFormSubmitEventOnForwardNavigation,
  UpdateAppliedDiscountAmountAction,
} from '@arc/unified-payments-frontend/shared-payment';
import { AddPaymentMethodForm } from '@arc/unified-payments-frontend/shared-payment-accounts';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const PoiSelectPaymentMethodComponentActions = createActionGroup({
  source: 'POI Select Payment Method Component',
  events: {
    'Initialize Select Payment Method Step': emptyProps(),
    'Payment Account Selected': props<{
      payload: PaymentAccount;
    }>(),
    'Payable Restrictions Applied': props<{
      payload: AppliedPayableRestriction[];
    }>(),
    'Discounts Updated': props<{
      payload: UpdateAppliedDiscountAmountAction;
    }>(),
    'Credit Applied': props<{
      payload: CreditAppliedActionPayload;
    }>(),
    'Submitted Add Pad Agreement Form': props<{
      payload: PadAgreementFormSubmitEvent;
    }>(),
    'Canceled Add Pad Agreement Form': emptyProps(),
    'Twikey Signature Failed': props<{
      payload: {
        paymentMethodDisplayName: string;
      };
    }>(),
    'Selected Bank Account Missing Pad': emptyProps(),
    'Submitted Add Pad Form For Selected Bank Account': props<{
      payload: PadAgreementFormSubmitEvent;
    }>(),
    'Signed Pad Separately For Selected Bank Account': emptyProps(),
    'Step Submitted For Proceed to Review': props<{
      selectPaymentMethod: SelectPaymentMethodFormSubmitEventOnForwardNavigation;
    }>(),
    'Step Submitted For Back To Payment Details': props<{
      selectPaymentMethod: SelectPaymentMethodFormSubmitEventOnBackNavigation;
    }>(),
    'Remote Card Capture Success': props<{
      paymentAccountData: PaymentAccountsPushNotificationMetadata;
      paymentMethod: AddPaymentMethodFormSubmitEvent;
      paymentMethodForm: AddPaymentMethodForm;
    }>(),
  },
});
